import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

type DeleteDisbursementRowParams = {
    caseUUID: string;
    rowId: string;
};

export const useDeleteDisbursementRowMutation = (): UseMutationResult<
    void,
    Error,
    DeleteDisbursementRowParams
> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ rowId }) => {
            const response = await fetch(apiUrl(`/disbursement/${rowId}`), {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
            });
            await handleJsonApiError(response);
        },
        onSuccess: async (_data, { caseUUID }) => {
            await queryClient.invalidateQueries({
                queryKey: ["disbursement", caseUUID],
            });
        },
    });
};
